module.exports = __webpack_public_path__ + "media/luxury-2026/terrace-entry-f76e5c46.jpg";